import clsx from 'clsx';
import { PropsWithChildren, useContext } from 'react';
import { AccordionContext, useAccordionButton } from 'react-bootstrap';
import BootstrapAccordion from 'react-bootstrap/esm/Accordion';

interface Props {
  header: React.ReactNode;
  headerActions?: React.ReactNode;
  open?: boolean;
  className?: {
    container?: string;
    header?: string;
    body?: string;
  };
}

function AccordionToggle({
  children,
  eventKey,
  callback,
  className,
}: PropsWithChildren<{
  eventKey: string;
  callback?: (eventKey: string) => void;
  className?: string;
}>) {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <button
      className={clsx(
        'btn btn-flush w-100 align-items-start fw-normal fs-base d-flex justify-content-between align-items-center pe-6 rotate collapsible',
        isCurrentEventKey ? 'active' : 'collapsed',
        className
      )}
      aria-expanded={isCurrentEventKey}
      onClick={decoratedOnClick}
    >
      {children}
      <i className='bi bi-chevron-down rotate-n180 p-0'></i>
    </button>
  );
}

export default function SingleAccordion({
  header,
  headerActions,
  open,
  className,
  children,
}: PropsWithChildren<Props>) {
  return (
    <BootstrapAccordion className='accordion' defaultActiveKey={open ? '0' : ''}>
      <BootstrapAccordion.Item
        className={clsx('accordion-item', className?.container)}
        eventKey='0'
      >
        <div className='d-flex align-items-center'>
          <AccordionToggle eventKey='0' className={clsx('flex-grow-1', className?.header)}>
            {header}
          </AccordionToggle>
          {headerActions && <div className='px-4 flex-shrink-0'>{headerActions}</div>}
        </div>
        <BootstrapAccordion.Body className={clsx('accordion-body', className?.body ?? 'pt-2')}>
          {children}
        </BootstrapAccordion.Body>
      </BootstrapAccordion.Item>
    </BootstrapAccordion>
  );
}
